import type { ReactNode } from 'react';
import { PageHeader as UIPageHeader } from '../ui';

/**
 * Page title + optional subtitle + right-aligned actions.
 *
 * Thin compatibility shim over the design-system {@link UIPageHeader} (`@/ui`) so pages
 * still importing `components/PageHeader` render the Chakra header and stay MUI-free.
 * New / migrated screens should import `PageHeader` from `../ui` directly (it also
 * supports breadcrumbs + an opt-in brand eyebrow); this shim maps the legacy
 * `subtitle` prop to the design-system `description`.
 */
export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}) {
  return <UIPageHeader title={title} description={subtitle} actions={actions} />;
}
